<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 w-100">
        <div class="d-flex align-items-center gap-2">
          <h6 class="modal-title" i18n>Send Template</h6>
        </div>
        <div class="flex-fill"></div>
        <button class="btn btn-light" (click)="prevStep()" [disabled]="isSending" *ngIf="hasPrev()">
          <i class="far fa-arrow-left"></i> <ng-container i18n>Back</ng-container>
        </button>
        <button
          class="btn btn-secondary-info"
          (click)="nextStep()"
          [disabled]="isSending || placeFieldsFormCom?.editor?.isEditorReady === false"
          *ngIf="currentStep !== steps.DocumentDetails"
        >
          <ng-container i18n>Next</ng-container> <i class="far fa-arrow-right ml-1 mr-0"></i>
        </button>
        <button class="btn btn-warning" *ngIf="currentStep === steps.PlaceFields" (click)="onPreview()">
          <i class="far fa-eye"></i> <ng-container i18n>Preview</ng-container>
        </button>
        <ng-container *ngIf="onlyMeSigner && template.type !== templateTypes.Document; else sendBtn">
          <button
            class="btn btn-secondary-info"
            (click)="onSignIt()"
            [disabled]="isSending"
            *ngIf="currentStep === steps.DocumentDetails"
          >
            <i [ngClass]="isSending ? 'far fa-spin fa-spinner' : 'fas fa-signature'"></i> Sign
          </button>
        </ng-container>
        <ng-template #sendBtn>
          <button
            class="btn btn-secondary-info"
            (click)="onSend()"
            [disabled]="isSending"
            *ngIf="currentStep === steps.DocumentDetails"
          >
            <i [ngClass]="isSending ? 'far fa-spin fa-spinner' : 'fas fa-paper-plane'"></i>
            <ng-container i18n>Send</ng-container>
          </button>
        </ng-template>
      </div>
      <a (click)="close()" class="cstm-close" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body p-0" #modalBody>
      <mat-stepper [linear]="true" #stepper class="m-3">
        <mat-step i18n-label label="Add Signer" [state]="stepper.selectedIndex > 0 ? 'done' : 'number'">
          <ng-template matStepContent>
            <div class="container-box p-3">
              <div class="bg-active2 p-3 rounded">
                <div class="d-grid gap-3 mb-3" style="grid-template-columns: 2fr 1fr">
                  <div class="text-semi-bold">
                    <span class="badge badge-circle badge-light border text-md">1</span>
                    <ng-container i18n> Who will be signing the template? </ng-container>
                  </div>
                  <div class="text-semi-bold" i18n>Signing Order</div>
                </div>
                <div class="pl-4">
                  <app-signers-with-role
                    [form]="signersForm"
                    [templateType]="template?.type"
                    [isSignerCustomizable]="template?.type !== templateTypes.Form"
                  ></app-signers-with-role>
                </div>
              </div>
            </div>
          </ng-template>
        </mat-step>
        <mat-step
          i18n-label
          label="Place Fields"
          [optional]="true"
          [state]="stepper.selectedIndex > 1 ? 'done' : 'number'"
        >
          <ng-template matStepContent>
            <app-place-fields-form
              #placeFieldsFormCom
              [form]="fieldsForm"
              [templateType]="template?.type"
              [templateFileUrl]="template?.pdf_file_url"
              [roles]="template?.roles"
              [style.height.px]="modalBody.offsetHeight - 90"
            ></app-place-fields-form>
          </ng-template>
        </mat-step>
        <mat-step
          i18n-label
          label="Template Details"
          [optional]="true"
          [state]="stepper.selectedIndex > 2 ? 'done' : 'number'"
        >
          <ng-template matStepContent>
            <div class="container-box p-3">
              <app-send-contract-info-form
                [form]="contractInfoForm"
                [fillBeforeSendingFields]="getFillBeforeSendingFields | call : fieldsForm"
                [isInquiryRequired]="
                  isBookingRequired | call : sendTemplateService : template?.type : placeFieldsFormCom.getFieldsConfig()
                "
                [signInApp]="template?.type !== templateTypes.Document && onlyMeSigner"
              >
              </app-send-contract-info-form>
            </div>
          </ng-template>
        </mat-step>
        <ng-template matStepperIcon="done">
          <i class="cs-icon cs-icon-check2 text-xs"></i>
        </ng-template>
        <ng-template matStepperIcon="edit">
          <i class="cs-icon cs-icon-check2 text-xs"></i>
        </ng-template>
      </mat-stepper>
    </div>
  </div>
</div>
